import React, { useEffect, useState } from 'react';

import EditSVG from '../assets/svg/edit';
import { SVGWrapper, FlexRow, ButtonWrapper } from './css';
import CancelSVG from '../assets/svg/cancel';
import SaveSVG from '../assets/svg/save';
import DeleteSVG from '../assets/svg/delete';
import { changeService, saveService } from './saveSchemaToDB';

export default function ServiceLabel({
  serviceLabel,
  offeringId,
  groupIndex,
  serviceIndex,
  setSavingData,
  fullyManagedAdminData,
  setFullyManagedAdminData
}) {
  const [label, setLabel] = useState(serviceLabel);
  const [editMode, setEditMode] = useState(!serviceLabel);

  const handleSave = async () => {
    const clonedAdminData = JSON.parse(JSON.stringify(fullyManagedAdminData));
    let groupId =clonedAdminData[groupIndex].id ;
    let serviceId =clonedAdminData[groupIndex].ServicesInGroup[serviceIndex].id;

    if (label) {
        try{
        setSavingData(true);
        if(serviceId)
        {
            await changeService(serviceId,{name:label,isSaved:true,ord:serviceIndex});
        }
        else
        {
            serviceId = await saveService({
                groupId,
                offeringId,
                ord:serviceIndex,
                name: label,
                quantityLabel: '',
                isSaved:true
            });
            clonedAdminData[groupIndex].ServicesInGroup[serviceIndex].id= serviceId;
            clonedAdminData[groupIndex].ServicesInGroup[serviceIndex].groupId= groupId;
            clonedAdminData[groupIndex].ServicesInGroup[serviceIndex].offeringId= offeringId;
          
        }
        clonedAdminData[groupIndex].ServicesInGroup[serviceIndex].name = label;
        setFullyManagedAdminData(clonedAdminData);
        setEditMode(false);
        }
        catch{
            console.log("An error occurred while saving data");
            setSavingData(false);
        }
        finally{
            setSavingData(false);
        }
    }
  };

  const handleCancel = () => {
    setLabel(serviceLabel);
    setEditMode(false);
  };

  return (
    <FlexRow>
      {editMode ? (
        <input
          type="text"
          value={label}
          style={{ color: '#242424', fontWeight: 700 }}
          onChange={e => setLabel(e.target.value)}
        ></input>
      ) : (
        serviceLabel
      )}

      <ButtonWrapper>
        {editMode ? (
          <>
            <SVGWrapper onClick={handleCancel}>
              <CancelSVG />
            </SVGWrapper>
            <SVGWrapper onClick={handleSave}>
              <SaveSVG color="#ffffff" />
            </SVGWrapper>
          </>
        ) : (
          <>
            <SVGWrapper onClick={() => setEditMode(true)}>
              <EditSVG />
            </SVGWrapper>
          </>
        )}
      </ButtonWrapper>
    </FlexRow>
  );
}
